import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import EventBlockData from './Data';
import EventBlockView from './View';

const EventBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <EventBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <EventBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(EventBlockEdit);
